import { render, staticRenderFns } from "./SelectResource.vue?vue&type=template&id=00a6de78&"
import script from "./SelectResource.vue?vue&type=script&lang=ts&"
export * from "./SelectResource.vue?vue&type=script&lang=ts&"
import style0 from "./SelectResource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports